import {Component, Input} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator} from '@angular/forms';

@Component({
    selector: 'employee-request-textarea',
    templateUrl: './request-textarea.component.html',
    styleUrls: ['./request-textarea.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: RequestTextareaComponent,
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: RequestTextareaComponent,
            multi: true
        }
    ]
})
export class RequestTextareaComponent implements ControlValueAccessor, Validator {

    @Input() title: string;
    @Input() placeholder: string = 'Enter';
    @Input() isRequired = false;
    @Input() maxLength = 1000;
    @Input() infoText = '';
    @Input() textHeight = 96;

    value: string = '';
    touched = false;
    invalid = false;

    currentCharCount = 0;


    validate(control: AbstractControl): ValidationErrors | null {
        this.invalid = false;

        if (!this.value && this.isRequired) {
            this.invalid = true;
            return {required: true};
        }

        return null;
    }

    writeValue(value: string): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
    }

    inputHandler($event: Event): void {
        this.touched = true;
        this.onChange(this.value);
        this.onTouch();
        this.currentCharCount = this.value.length;
    }

    private onChange: any = () => {
    }

    private onTouch: any = () => {
    }

}
